module.exports = __webpack_public_path__ + "img/Last image OOBE Traditional Chinese.37e4e8ab.png";